export enum RollCompetitionsQueryKeys {
  Primary = 'roll-competitions',
}
